var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDeniedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "98px",
    viewBox: "0 0 105 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning-sign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Baby-Odin-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Copy-3",
    transform: "translate(-668.000000, -135.000000)",
    stroke: "#333333",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-sign",
    transform: "translate(669.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.01534328,84.0497128 L44.6331157,4.12143599 C45.9917602,1.58332333 48.6297966,0 51.5,0 C54.3702034,0 57.0082398,1.58332333 58.3668843,4.12143599 L101.984657,84.0497128 C103.357949,86.5190386 103.336897,89.5313353 101.929226,91.981074 C100.521555,94.4308127 97.9345946,95.9571834 95.1177724,96 L7.88222759,96 C5.06540545,95.9571834 2.47844479,94.4308127 1.07077384,91.981074 C-0.336897114,89.5313353 -0.357949402,86.5190386 1.01534328,84.0497128 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 28,
    x2: 51,
    y2: 68,
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 52,
    cy: 81,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDeniedIcon);
export default __webpack_public_path__ + "static/media/AccessDeniedIcon.bb242e3f.svg";
export { ForwardRef as ReactComponent };